import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, HostBinding, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SiLink } from '@simpl/siemens-brand-ng/models';

class SiCopyrightComponent {
    constructor() {
        this.intranet = false;
        this.startYear = 1996;
        this.company = 'sag';
        this._copyright = true;
    }
    ngOnInit() {
        this.updateCopyright();
    }
    ngOnChanges(changes) {
        if (changes.company || changes.copyright || changes.copyrightYear || changes.intranet || changes.startYear) {
            this.updateCopyright();
        }
    }
    updateCopyright() {
        const year = this.copyrightYear ?? new Date().getFullYear();
        const intranet = this.intranet ? 'Intranet' : '';
        if (this.company === 'se') {
            this.copyright = `© Siemens Energy ${intranet} ${year}`;
        }
        else {
            this.copyright = `© Siemens ${intranet} ${this.startYear} – ${year}`;
        }
    }
}
SiCopyrightComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiCopyrightComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SiCopyrightComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.7", type: SiCopyrightComponent, selector: "si-copyright", inputs: { copyright: "copyright", intranet: "intranet", copyrightYear: "copyrightYear", startYear: "startYear", company: "company" }, host: { properties: { "class.si-copyright": "this._copyright" } }, usesOnChanges: true, ngImport: i0, template: `{{copyright}}`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiCopyrightComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'si-copyright',
                    template: `{{copyright}}`,
                }]
        }], propDecorators: { copyright: [{
                type: Input
            }], intranet: [{
                type: Input
            }], copyrightYear: [{
                type: Input
            }], startYear: [{
                type: Input
            }], company: [{
                type: Input
            }], _copyright: [{
                type: HostBinding,
                args: ['class.si-copyright']
            }] } });

class SiLegalLinksComponent {
    constructor() {
        this.company = 'sag';
        this._footerLinks = [];
        this._siLegalLinks = true;
        this.trackByIndex = (index) => index;
    }
    ngOnInit() {
        this.updateFooterLinks();
    }
    ngOnChanges(changes) {
        if (changes.company) {
            this.updateFooterLinks();
        }
    }
    updateFooterLinks() {
        if (!this.footerLinks?.length) {
            if (this.company === 'se') {
                this._footerLinks = [
                    new SiLink('Corporate Information', 'https://www.siemens-energy.com/corporate-information'),
                    new SiLink('Privacy Notice', 'https://www.siemens-energy.com/privacy-notice'),
                    new SiLink('Cookie Notice', 'https://www.siemens-energy.com/cookie-notice'),
                    new SiLink('Terms of Use', 'https://www.siemens-energy.com/terms-of-use'),
                    new SiLink('Digital ID', 'https://www.siemens-energy.com/digital-id'),
                    new SiLink('Siemens Energy is a registered trademark licensed by Siemens AG.', 'https://www.siemens-energy.com/global/en.html'),
                ];
            }
            else {
                this._footerLinks = [
                    new SiLink('Corporate Information', 'https://www.siemens.com/corporate-information'),
                    new SiLink('Privacy Notice', 'https://www.siemens.com/privacy-notice'),
                    new SiLink('Cookie Notice', 'https://www.siemens.com/cookie-notice'),
                    new SiLink('Terms of Use', 'https://www.siemens.com/terms-of-use'),
                    new SiLink('Digital ID', 'https://www.siemens.com/digital-id'),
                ];
            }
        }
        else {
            this._footerLinks = this.footerLinks;
        }
    }
}
SiLegalLinksComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiLegalLinksComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SiLegalLinksComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.7", type: SiLegalLinksComponent, selector: "si-legal-links", inputs: { company: "company", footerLinks: "footerLinks" }, host: { properties: { "class.si-legal-links": "this._siLegalLinks" } }, usesOnChanges: true, ngImport: i0, template: `
    <div class="nav just-content-end flex-column flex-lg-row">
      <div *ngFor="let link of _footerLinks; trackBy: trackByIndex" class="si-header-item">
        <a [href]="link.url" class="nav-link" target="_blank" rel="noopener">{{link.name}}</a>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiLegalLinksComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'si-legal-links',
                    template: `
    <div class="nav just-content-end flex-column flex-lg-row">
      <div *ngFor="let link of _footerLinks; trackBy: trackByIndex" class="si-header-item">
        <a [href]="link.url" class="nav-link" target="_blank" rel="noopener">{{link.name}}</a>
      </div>
    </div>
  `,
                }]
        }], propDecorators: { company: [{
                type: Input
            }], footerLinks: [{
                type: Input
            }], _siLegalLinks: [{
                type: HostBinding,
                args: ['class.si-legal-links']
            }] } });

class SiFooterModule {
}
SiFooterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiFooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SiFooterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.7", ngImport: i0, type: SiFooterModule, declarations: [SiCopyrightComponent, SiLegalLinksComponent], imports: [CommonModule, RouterModule], exports: [SiCopyrightComponent, SiLegalLinksComponent] });
SiFooterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiFooterModule, imports: [CommonModule, RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: SiFooterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiCopyrightComponent, SiLegalLinksComponent],
                    imports: [CommonModule, RouterModule],
                    exports: [SiCopyrightComponent, SiLegalLinksComponent],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SiCopyrightComponent, SiFooterModule, SiLegalLinksComponent };
